import React from 'react';
import { Breadcrumb, BreadcrumbItem } from 'carbon-components-react';
import './PatientBreadcrumb.scss';
import { PatientData } from '../../models/PatientData';

export interface PatientBreadcrumbProps {
  patient: PatientData;
}

export const PatientBreadcrumb: React.FC<PatientBreadcrumbProps> = (
  props: PatientBreadcrumbProps
) => {
  return (
    <div className="breadcrumb-container">
      <Breadcrumb noTrailingSlash>
        <BreadcrumbItem data-testid="patients-link" href="/patients">
          Patients
        </BreadcrumbItem>
        <BreadcrumbItem isCurrentPage href="/patient">
          {props.patient?.name.given + ' ' + props.patient?.name.family}
        </BreadcrumbItem>
      </Breadcrumb>
    </div>
  );
};
